import { render } from "./BrandHours.vue?vue&type=template&id=057ce892&ts=true"
import script from "./BrandHours.vue?vue&type=script&lang=ts"
export * from "./BrandHours.vue?vue&type=script&lang=ts"

import "./BrandHours.vue?vue&type=style&index=0&id=057ce892&lang=css"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__